// apps/client/src/components/XeroSyncTransactions.tsx

import React from 'react';
import { XeroSyncTransactionsResponse, XeroSyncType } from '@avanzu/types';
import { XeroSyncButton } from './XeroSyncButton';

interface XeroSyncTransactionsProps {
  onSyncComplete?: (result: XeroSyncTransactionsResponse) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
  startDate?: Date;
  endDate?: Date;
}

const XeroSyncTransactions: React.FC<XeroSyncTransactionsProps> = (props) => {
  return (
    <XeroSyncButton<XeroSyncTransactionsResponse>
      syncType={XeroSyncType.TRANSACTIONS}
      pollInterval={1000}
      {...props}
    />
  );
};

export default XeroSyncTransactions;
